// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-image-view .video-photo{width:100%}.ac-view .ac-info{line-height:1.5625rem;color:#222;border-color:1px solid #ccc;background:-webkit-gradient(linear,left top,left bottom,from(#fff),to(#f1f1f1));background:linear-gradient(#fff,#f1f1f1)}.ac-view .ac-info .video-desc{padding:0 .3125rem}.ac-view .ac-info{font-size:1rem}.ac-view .ac-info .video-line{padding:.3125rem}.ac-view .video-divider{margin:.3125rem;border-color:#000;font-size:1rem}.ac-view{color:#fff}", ""]);
// Exports
module.exports = exports;
